import React from 'react';
import { createRoot } from 'react-dom/client';
import { UIOverlay } from './UIOverlay';
import './css/index.css';

// Conditionally import Bootstrap only in development
if (import.meta.env.DEV) {
  import('bootstrap/dist/css/bootstrap.min.css');
}

export let rootElement: HTMLElement;

export function initializeUI(): void {
  const uiContainer = document.createElement('div');
  uiContainer.id = 'ui-overlay-root';
  uiContainer.style.cssText = `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: inherit;
    pointer-events: none;
    z-index: 1;
    overflow: hidden;
  `;

  rootElement = uiContainer;
  
  uiContainer.addEventListener('click', (e) => {
    if (e.target === uiContainer) {
      e.stopPropagation();
    }
  });

  const style = document.createElement('style');
  style.textContent = `
    #ui-overlay-root > * {
      pointer-events: auto;
    }
  `;
  document.head.appendChild(style);
  
  document.getElementById('solitaire-container')?.appendChild(uiContainer);
  
  window.addEventListener("resize", () => {
    rootElement.style.width = '100%';
  });

  const root = createRoot(uiContainer);
  root.render(React.createElement(UIOverlay));
}



export { UIOverlay } from './UIOverlay';
export { GameApp } from './components/GameApp';
export { GameStats } from './components/GameStats';
export { GameButtons } from './components/GameButtons';
export type { UIState, GameStats as GameStatsType } from './types/gameUI';

export { uiStore } from './store';
export type { UIRootState } from './store';
export { UIActionTypes } from './types/gameUI';
export * from './store/actions/gameUIActions';
export { updateUIState } from './store/actions/gameUIActions';

